import Component from '../Component';
import React from 'react';

export default class IconRadio extends Component {

	static defaultProps = {
		color: '#666666'
	};

	handleChange() {
		this.props.onChange(!this.props.value);
		//this.props.onBlur(!this.props.value);
	}

	render() {
		const checked = !!this.props.value;
		const cn = checked ? 'icon-radio-checked' : 'icon-circle';
		return (
			<div style={{display: 'inline'}} onClick={() => this.handleChange()}>
				<span style={{color:this.props.color, fontSize: 14}} className={cn}></span>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/IconRadio.js